import { gql } from "@/__generated__/gql";

export const INVITES_BY_ROLE = gql(`
  query Invites(
    $orgId: ID!
    $roles: [DashInviteRoleEnum!]!
    $first: Int
    $last: Int
    $after: String
    $before: String
    $ordering: [DashInviteOrderingInput!]!
  ) {
    node(id: $orgId) {
        ... on Organization {
        id
        dashInvites(first: $first, after: $after, roles: $roles, ordering: $ordering, before: $before, last: $last) {
          edges {
            node {
              id
              email
              firstName
              invitedAt
              lastName
              phoneNumber
              role
            }
            cursor
          }
          pageInfo {
            hasPreviousPage
            startCursor
            endCursor
            hasNextPage
          }
          totalCount
        }
      }
    }
  }
`);
